import React, { useEffect, useState ,useRef} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import AcronCard from '../Card/AcronCard/Acron';
// import BatterixCard from '../Card/BatterixCard/Batterix';
// import BlackRockk from '../Card/BlackRock/BlackRock';
// import BlythneGas from '../Card/BlythneGas/BlythneGas';
// import Blythnecoal from '../Card/BlythneCoal/BlythneCoal';
// import BlythneHydro from '../Card/BlythneHydro/Blythnehydro';
// import AcronRep from '../Card/AcronRep/AcronRep';
// import BlythneTransmission from '../Card/BlythneTransmission/BlythneTransmission';
import axios from 'axios';
import LoadingSpinner from '../Loading/Loading';
import { useDataContext } from "../DataContext/PortfolioDataContext";

// Import icons statically
import Batteryicon from '../../assets/BatteryIcon.png';
import Solaricon from '../../assets/SolarIcon.png';
import Windicon from '../../assets/WindIcon.png';
import Gasicon from '../../assets/GasIcon.png';
import Coalicon from '../../assets/Coalicon.png';
import Hydroicon from '../../assets/Hydroicon.png';
import Repicon from '../../assets/Repicon.png';
import Transmissionicon from '../../assets/Transmissionicon.png';
import { getAuthToken } from "../../services/authService-sighup";
import { datadogRum } from "@datadog/browser-rum";
import DynamicCard from '../Card/Dynamic-card';
import config from './card-config.json';
import { useEntitlements } from '../DataContext/EntitlementsContext';
import { slugify } from "../AssetDashboard/slugify";
import { tabsConfig } from '../AssetDashboard/tabsConfig';
import { datadogLogs } from '@datadog/browser-logs';
import { extractTimeValue } from './timeUtils';
import PortfolioRevenueWidget from '../DataContext/PortfolioRevenueWidget';


interface CardGridProps {
  selectedAssetType: string;
  selectedISO: string | null;
  sortBy: string | null;
  sortOrder: string;
  groupBy: string | null;
  searchQuery: string;
  refreshCounter: number;

}

const CardGrid: React.FC<CardGridProps> = ({
  selectedAssetType,
  searchQuery,
  selectedISO,
  sortBy,
  sortOrder,
  groupBy,
  refreshCounter
}) => {

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const { assetData, setAssetData,error,setError } = useDataContext();
  const [noResults, setNoResults] = useState(false);
  const { hasLoadedOnce, loading, entitlements } = useEntitlements();
  const hasAccess = (path: string) => entitlements.some(e => e.po_path === path);
  const hasRevenueWidgetAccess = entitlements.some(
    (item) =>
      item.po_type_code?.toUpperCase() === "UI_ELEMENT" &&
      typeof item.po_path === "string" &&
      item.po_path.trim().toLowerCase() === "/portfolio-landing-revenue-report" &&
      typeof item.privilege === "string" &&
      ["read", "write", "admin"].includes(item.privilege.trim().toLowerCase())
  );




  useEffect(() => {
    if (!hasLoadedOnce) return;

    const fetchData = async () => {
      try {
        const hasLandingAccess = entitlements.some(
          (item) =>
            item.po_type_code?.toUpperCase() === "UI_ELEMENT" &&
            typeof item.po_path === "string" &&
            item.po_path.trim().toLowerCase() === "/landing"
        );
  
        if (!hasLandingAccess) {
          setAssetData([]);     
          setIsLoading(false);
          setError("You do not have permission to view this page.");
          return; 
        }
  
  
        const url = process.env.REACT_APP_ANALYTICS_API as string;
        const fullUrl = `${url}/metrics/portfolio-landing`;
        const userEmail = localStorage.getItem("userEmail");

        // const payload = {
        //   filters: {},
        //   metric_group: "ASSET_PORTFOLIO_LANDING",
        //   date_range: {
        //     start_date: "today",
        //   },
        //   operation: "GET_ASSET_PORTFOLIO_ANALYTICS",
        //   user: userEmail || "",
        // };
const payload = {
  filters: {},
  metric_group: "ASSET_PORTFOLIO_LANDING",
  include_yesterday_revenue: hasRevenueWidgetAccess,
  user: userEmail || "",
};
        const token = await getAuthToken();
        const subscriptionKey =
          process.env.REACT_APP_SUBSCRIPTION_KEY_TIMESERIES as string;

        setIsLoading(true);

        const response = await axios.post(fullUrl, payload, {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            "Ocp-Apim-Subscription-Key": subscriptionKey ?? "",
            Product: process.env.REACT_APP_PRODUCT_APIM ?? "",
          },
        });

        if (response.status === 200 && response.data.status === "Success") {
          const formatNumber = (value: any) => {
            const num = parseFloat(value);
            
            return isNaN(num) || num === 0 ? "0.00" : num.toFixed(2);
          };

          // const assetFilters = response.data.request.filters.asset_filter;

          // const datetimeAssetMap: { time: string; asset_ids: number[] }[] = assetFilters.map((filter: any) => {
          //   const datetime = filter.datetime?.value ?? "";
          //   const time = datetime.split(" ")[1] ?? "";
          //   const assetIds = filter.asset_id?.value ?? [];
          //   return {
          //     time,
          //     asset_ids: assetIds,
          //   };
          // });

          function formatDateTime(input: string): string {
            if (!input) return "";
            if (input.includes("T")) {
              return input.length === 16 ? `${input}:00` : input;
            }
            const [datePart, timePart] = input.split(" ");
            const [year, month, day] = datePart.split("-");
            const [hour, minute] = timePart.split(":");
            return `${year}-${month}-${day}T${hour}:${minute}:00`;
          }

          function addDays(dateStr: string, days: number): string {
            const [datePart, timePart] = dateStr.split("T");
            const [year, month, day] = datePart.split("-").map(Number);
          
            // Create date in local time and add days
            const date = new Date(year, month - 1, day + days);
          
            // Rebuild string with original timePart preserved
            const newDatePart = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
            return `${newDatePart}T${timePart}`;
          }

          const normalizeTimestamp = (input?: string | null): string | null => {
            if (!input || typeof input !== "string") return null;
            const normalized = input
              .trim()
              .replace(" ", "T")
              .replace(/([+-]\d{2}:\d{2}|Z)$/i, "")
              .replace(/\.\d+$/, "");
            return normalized || null;
          };

          const getTimestampCandidates = (timestamp?: string | null): string[] => {
            const normalized = normalizeTimestamp(timestamp);
            if (!normalized) return [];
            return [normalized, `${normalized}+00:00`, `${normalized}Z`];
          };

          const getSeriesValue = (series: any, preferredTimestamp?: string | null) => {
            if (!series || typeof series !== "object") return null;

            const candidates = getTimestampCandidates(preferredTimestamp);
            for (const candidate of candidates) {
              if (series[candidate] != null) return series[candidate];
            }

            const normalizedPreferred = normalizeTimestamp(preferredTimestamp);
            if (normalizedPreferred) {
              for (const key of Object.keys(series)) {
                if (normalizeTimestamp(key) === normalizedPreferred && series[key] != null) {
                  return series[key];
                }
              }
            }

            // Fall back to date-only match (handles metrics like DA_RENEW_FCST whose keys
            // use a different time-of-day than the request datetime)
            const preferredDateOnly = normalizedPreferred?.substring(0, 10);
            if (preferredDateOnly) {
              for (const key of Object.keys(series)) {
                const normalizedKey = normalizeTimestamp(key);
                if (normalizedKey?.startsWith(preferredDateOnly) && series[key] != null) {
                  return series[key];
                }
              }
            }

            const firstNonNullValue = Object.values(series).find((value) => value != null);
            return firstNonNullValue ?? null;
          };

          // For multi-day forecast series (e.g. DA_RENEW_FCST), keys are forecast dates
          // that may differ in time-of-day from the request datetime. Sort keys by
          // normalized timestamp and return the value at the given 0-based index.
          const getForecastByIndex = (series: any, index: number): any => {
            if (!series || typeof series !== "object") return null;
            const sorted = Object.entries(series)
              .filter(([, v]) => v != null)
              .sort(([a], [b]) =>
                (normalizeTimestamp(a) ?? a).localeCompare(normalizeTimestamp(b) ?? b)
              );
            return sorted[index]?.[1] ?? null;
          };

          const RequestDateTime =  response.data.request.filters.datetime?.value ?? "";
          const formattedValue = formatDateTime(RequestDateTime);
          const formattedData = response.data.data.map((asset: any) => {
            const latestTimestamp = formattedValue;
            const day1Timestamp = latestTimestamp;
            const day2Timestamp = addDays(latestTimestamp, 1);
            const meterMw = getSeriesValue(asset.METERED_OUTPUT, latestTimestamp);
            const daAwd = getSeriesValue(asset.DA_AWD, latestTimestamp);
            const rtLmp = getSeriesValue(asset.RT_LMP, latestTimestamp);
            const daLmp = getSeriesValue(asset.DA_LMP, latestTimestamp);
            const gasBurnRt = getSeriesValue(asset.GAS_BURN_RT, latestTimestamp);
            const gasBurn = gasBurnRt ?? getSeriesValue(asset.GAS_BURN, latestTimestamp);
            const totalCycle = getSeriesValue(asset.TOTAL_CYCLE, latestTimestamp);
            const maxEnergy = getSeriesValue(asset.MAX_SOC, latestTimestamp);
            const socMw = getSeriesValue(asset.RT_SOC, latestTimestamp);
            const windSpeed = getSeriesValue(asset.WIND_SPEED, latestTimestamp);
            const unitStatus = getSeriesValue(asset.UNIT_STATUS, latestTimestamp);
            const regStatus = getSeriesValue(asset.REG_STATUS, latestTimestamp);
            const sunrise = getSeriesValue(asset.SUNRISE, latestTimestamp);
            const sunset = getSeriesValue(asset.SUNSET, latestTimestamp);
            const day1Forecast = getForecastByIndex(asset.DA_RENEW_FCST, 0);
            const day2Forecast = getForecastByIndex(asset.DA_RENEW_FCST, 1);
         

            // console.log("Day1 forecast",day1Timestamp)
            
            // const matchingTimeEntry = datetimeAssetMap.find(entry =>
            //   entry.asset_ids.map(String).includes(String(asset.ASSET_ID))
            // );
            // const assetTime = matchingTimeEntry?.time ?? "00:00:00";
            // const assetTime = latestTimestamp.split("T")[1] ?? "00:00:00";
            const resourceNames = asset.RESOURCE_NAME.join(",");
            const betmObjectkey = asset.BETM_OBJECTKEY.join(",");
            const [revenuePeriod, yesterdayRevenueValue] = Object.entries(
              asset.YESTERDAY_TOTAL_REVENUE ?? {}
            )[0] ?? [];
            const yesterdayRevenue = Number(yesterdayRevenueValue ?? 0);
            return {

              asset_id: asset.ASSET_ID,
              asset_name: asset.ASSET_NAME,
              ISO: asset.ISO_CODE,
              company_name: asset.COMPANY_NAME,
              participant_name: asset.PARTICIPANT_NAME,
              asset_type: asset.ASSET_TYPE,
              resource_name: resourceNames,
              betm_objectkey: betmObjectkey,
              yesterdayRevenue,
              revenuePeriod: typeof revenuePeriod === "string" ? revenuePeriod : undefined,
              icon: getAssetIcon(asset.ASSET_TYPE),
              RT_VOL: meterMw != null ? formatNumber(meterMw) : "-",
              DA_VOL: daAwd != null ? formatNumber(daAwd) : "-",
              RT_LMP: rtLmp != null ? `${formatNumber(rtLmp)}` : "-",
              DA_LMP: daLmp != null ? `${formatNumber(daLmp)}` : "-",
              gasBurnValue: gasBurn != null ? formatNumber(gasBurn) : null,
              cyclePercentage: totalCycle != null ? Math.round(Number(totalCycle)).toString() : null,
              maxEnergy: maxEnergy != null ? Math.round(Number(maxEnergy)).toString() : null,
              batteryLevel: socMw != null ? Math.round(Number(socMw)).toString() : null,
              windspeed: windSpeed != null ? windSpeed : null,
              unit_status: unitStatus != null ? unitStatus : null,
              reg_status: regStatus != null ? regStatus : null,
              sunriseTime: sunrise != null ? extractTimeValue(sunrise) : null,
              sunsetTime: sunset != null ? extractTimeValue(sunset) : null,
              Day1_Forecast: day1Forecast != null ? formatNumber(day1Forecast) : null,
              Day2_Forecast: day2Forecast != null ? formatNumber(day2Forecast) : null,
              current_time: extractTimeValue(asset.ASSET_TIME) ?? "00:00:00",
            };
          });

          setAssetData(formattedData);
          // console.log(formattedData)  
          sessionStorage.setItem("apiDataFetched", "true");
          setIsLoading(false);
          setError(null);
        } else {
          throw new Error("Unexpected response status");
        }
      } catch (error: any) {
      
        let errorMessage = "Failed to load data. Please try again later.";
        const statusCode = error?.response?.status;
        const apiError = error?.response?.data ?? error?.data ?? null;
        if (statusCode === 403) {
          errorMessage = "You need permission to access this site";
        } else if (apiError?.error?.error?.message) {
          errorMessage = apiError.error.error.message;
        } else if (apiError?.error?.message) {
          errorMessage = apiError.error.message;
        } else if (error?.message && !error.message.includes("status code")) {
          errorMessage = error.message;
        }
        errorMessage = errorMessage.replace(/^(\d+):\s*\1\s*/, "").replace(/^:\s*/, "");
        setError(errorMessage);
        setIsLoading(false);
      }
      };

      fetchData();
      }, [location, setAssetData, refreshCounter, hasLoadedOnce, entitlements]);


  const getAssetIcon = (type: string) => {
    switch (type) {
      case "Gas":
        return Gasicon;
      case "Solar":
        return Solaricon;
      case "Wind":
        return Windicon;
      case "Coal":
        return Coalicon;
      case "Hydro":
        return Hydroicon;
      case "Battery":
        return Batteryicon;
      case "Rep":
        return Repicon;
      case "Transmission":
        return Transmissionicon;
      default:
        return Batteryicon;
    }
  };
  const pendingNavigationRef = useRef<any>(null);

  const handleCardClick = (asset: any) => {
  
    datadogLogs.logger.info("[handleCardClick] State check", {
      hasLoadedOnce,
      loading,
      entitlementsCount: entitlements?.length,
      assetName: asset.asset_name
    });

    if (!hasLoadedOnce) {
      datadogLogs.logger.warn("[handleCardClick] First entitlements load not complete yet.", {
        assetName: asset.asset_name
      });
      return;
    }
    if (pendingNavigationRef.current) {
      datadogLogs.logger.warn("[handleCardClick] Navigation already pending.", {
        assetName: asset.asset_name
      });
      return;
    }
  
    if (loading) {
      datadogLogs.logger.info("[handleCardClick] Entitlements refreshing — allowing navigation.", {
        assetName: asset.asset_name
      });
    }
  
    pendingNavigationRef.current = true;
    doNavigation(asset, entitlements);
  };
  
  const doNavigation = (asset: any, entitlements: any[]) => {
    const entitledPaths = entitlements.map(e => e.po_path.toLowerCase().trim());
  
    const hasDashboardAccess = entitledPaths.some(path =>
      path.includes("/asset-dashboard")
    );
  
    if (!hasDashboardAccess) {
      datadogLogs.logger.warn("[handleCardClick] User has no /asset-dashboard access", {
        entitledPaths
      });
      return;
    }
  
    const slug = slugify(asset.asset_name);
  
    const accessibleTab = tabsConfig.tabs.find(tab => {
      const tabSlug = tab.label.toLowerCase().replace(/\s+/g, "-");
      return entitledPaths.some(path => path.includes(`/asset-dashboard/${tabSlug}`));
    });
  
    if (!accessibleTab) {
      datadogLogs.logger.warn("[handleCardClick] No accessible tab found for user.", {
        entitledPaths
      });
      return;
    }
  
    const tabSlug = accessibleTab.label.toLowerCase().replace(/\s+/g, "-");
    datadogLogs.logger.info("[doNavigation] Navigating to tab", {
      tabSlug,
      assetName: asset.asset_name
    });
  
    navigate(`/asset-dashboard/${tabSlug}/${slug}`, {
      state: {
        ASSET_ID: asset.asset_id,
        ASSET_NAME: asset.asset_name,
        ASSET_TYPE: asset.asset_type,
        ISO_CODE: asset.ISO,
      },
    });
  
    setTimeout(() => {
      pendingNavigationRef.current = false;
    }, 500);
  };
  
  // const renderCard = (asset: any) => {
  //   switch (asset.asset_type) {
  //     case "Battery":
  //       return <AcronCard data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Solar":
  //       return <BatterixCard data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Gas":
  //       return <BlythneGas data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Wind":
  //       return <BlackRockk data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Coal":
  //       return <Blythnecoal data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Hydro":
  //       return <BlythneHydro data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Transmission":
  //       return <BlythneTransmission data={asset} onClick={() => handleCardClick(asset)} />;
  //     case "Rep":
  //       return <AcronRep data={asset} onClick={() => handleCardClick(asset)} />;
  //     default:
  //       return null;
  //   }
  // };

  
  const applySorting = (data: any[]) => {
    if (!sortBy) return data; 
  
    const parseValue = (val: any) => {
      if (typeof val === "string" && val.startsWith("$")) {
        return parseFloat(val.replace("$", ""));
      }
      return typeof val === "string" && !isNaN(Number(val)) ? parseFloat(val) : val?.toString().toLowerCase?.() ?? val;
    };
  
    const effectiveSortOrder = sortBy === "" ? "Ascending" : sortOrder;
  
    return [...data].sort((a, b) => {
      const valueA = parseValue(a[sortBy]);
      const valueB = parseValue(b[sortBy]);
  
      if (valueA < valueB) return effectiveSortOrder === "Ascending" ? -1 : 1;
      if (valueA > valueB) return effectiveSortOrder === "Ascending" ? 1 : -1;
      return 0;
    });
  };
  

  const applyGrouping = (data: any[]) => {
    if (!groupBy) return [{ group: null, items: data }];
    const grouped = data.reduce((acc: any, item: any) => {
      const groupValue = item[groupBy];
      if (!acc[groupValue]) acc[groupValue] = [];
      acc[groupValue].push(item);
      return acc;
    }, {});
    return Object.keys(grouped).map((key) => ({
      group: key,
      items: grouped[key],
    }));
  };

  const filteredData = assetData.filter((asset) => {
    const normalize = (value: unknown): string => {
      if (value == null) return '';
      return String(value).toLowerCase().replace(/\s+/g, '').trim();
    };
  
    const normalizedSearchQuery = normalize(searchQuery);
  
    const matchesSearchQuery = Object.values(asset).some((value) => {
      const normalizedValue = normalize(value);
      return normalizedValue.includes(normalizedSearchQuery);
    });
  
    const matchesAssetType = selectedAssetType ? asset.asset_type === selectedAssetType : true;
    const matchesISO = selectedISO ? asset.ISO === selectedISO : true;
  
    return matchesSearchQuery && matchesAssetType && matchesISO;
  });
  
  useEffect(() => {
    setNoResults(filteredData.length === 0);
  }, [filteredData]);

  // Apply sorting
  const sortedData = applySorting(filteredData);
const topCards = sortedData.slice(0, 4);
const remainingCards = sortedData.slice(4);
  // Apply grouping
  const groupedData = applyGrouping(sortedData);


  return (
    <div className="w-full px-4 sm:px-6 lg:px-15 xl:px-20 py-5 bg-[#F7F7FF]">
      {isLoading ? (
        <div className="flex items-center justify-center h-[60vh]">
          <LoadingSpinner />
        </div>
      ) : error ? (
        <div className="absolute inset-0 flex items-center justify-center bg-white p-4 rounded-md shadow-md">
          <div className="text-center">
            <h4
              className={`text-xl font-semibold mt-4 whitespace-pre-wrap text-left ${
                error === "You need permission to access this site"
                  ? "text-gray-600 font-normal"
                  : "text-red-600"
              }`}
            >
              {error}
            </h4>
            <p className="text-gray-500 mt-1">
              Please try refreshing the page or check back later.
            </p>
          </div>
        </div>
      ) : (
        <div>
          {noResults && (
            <div className="absolute inset-0 flex items-center justify-center bg-white text-gray-600 font-semibold p-4">
              No matching results found. Try adjusting your filters.
            </div>
          )}
          <>
  {groupedData.map(({ group, items }: any, groupIndex: number) => {
    const renderCard = (asset: any, assetIndex: number) => {
      const cardConfig = config.find((cfg) => cfg.category === asset.asset_type);
      return (
        <div
          key={asset.asset_id || `asset-${assetIndex}`}
          onClick={() => datadogRum.addAction("Asset Clicked", { assetId: asset.asset_id, name: asset.asset_name })}
        >
          {cardConfig && (
            <div
              onClick={() => handleCardClick(asset)}
              title={!hasAccess("/asset-dashboard") ? "Access Restricted" : ""}
              className={hasAccess("/asset-dashboard") ? "cursor-pointer rounded-lg" : "cursor-not-allowed"}
            >
              <DynamicCard category={cardConfig.category} charts={cardConfig.charts} data={asset} />
            </div>
          )}
        </div>
      );
    };

    const topItems = groupIndex === 0 ? items.slice(0, 4) : items;
    const topLeftFirstRow = topItems.slice(0, 2);
    const topLeftSecondRow = topItems.slice(2, 4);
    const overflowItems = groupIndex === 0 ? items.slice(4) : [];
    const lgLeftColumnItems = groupIndex === 0 ? items.slice(0, 2) : [];
    const lgOverflowItems = groupIndex === 0 ? items.slice(2) : [];
    const showRevenueWidget = groupIndex === 0 && hasRevenueWidgetAccess;

    return (
      <div key={`group-${group || groupIndex}`}>
        {group && <h2 className="text-lg font-bold mb-4 mt-4">{group}</h2>}

        {/* Responsive top section: show revenue widget only for entitled users */}
        {showRevenueWidget ? (
          <>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:hidden">
              <div className="min-h-0 order-last md:col-span-2">
                <PortfolioRevenueWidget assetData={sortedData} />
              </div>
              {items.map(renderCard)}
            </div>

            <div className="hidden lg:grid xl:hidden lg:grid-cols-3 lg:auto-rows-[16rem] lg:gap-5">
              {lgLeftColumnItems.map((asset: any, index: number) => (
                <div
                  key={asset.asset_id || `lg-left-${index}`}
                  className={index === 0 ? "lg:col-start-1 lg:row-start-1" : "lg:col-start-1 lg:row-start-2"}
                >
                  {renderCard(asset, index)}
                </div>
              ))}
              <div className="min-h-0 lg:col-start-2 lg:col-span-2 lg:row-start-1 lg:row-span-2">
                <PortfolioRevenueWidget assetData={sortedData} />
              </div>
            </div>

            {lgOverflowItems.length > 0 && (
              <div className="mt-5 hidden lg:grid xl:hidden lg:grid-cols-3 lg:gap-5">
                {lgOverflowItems.map(renderCard)}
              </div>
            )}

            <div className="hidden xl:grid xl:grid-cols-4 xl:auto-rows-[16rem] xl:gap-5">
              {topLeftFirstRow.map(renderCard)}
              <div className="min-h-0 xl:col-start-3 xl:col-span-2 xl:row-start-1 xl:row-span-2 xl:w-[min(100%,calc(50%+28.625rem))] 2xl:w-[min(100%,calc(50%+32.625rem))]">
                <PortfolioRevenueWidget assetData={sortedData} />
              </div>
              {topLeftSecondRow.map(renderCard)}
            </div>

            {overflowItems.length > 0 && (
              <div className="mt-5 hidden xl:grid xl:grid-cols-4 xl:gap-5">
                {overflowItems.map(renderCard)}
              </div>
            )}
          </>
        ) : (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {items.map(renderCard)}
          </div>
        )}
      </div>
    );
  })}
</>
        </div>
      )}
    </div>
  );
  
};

export default CardGrid;
